module.exports = __webpack_public_path__ + "static/media/toxicity.54ac5e19.svg";